<template>
    <button
        type="button"
        class="br-btn"
        :class="{
            'br-btn--minimal': variant === 'minimal',
            'br-btn--preview': variant === 'preview'
        }"
        @click.prevent="sendRemindToOperator"
        :disabled="loading"
        v-if="hasOperator"
        :title="$t('post.page.button.restart')"
    >
        <i v-if="loading" class="fal fa-spinner-third fa-spin br-btn-icon"></i>
        <i v-else class="fal fa-bell br-btn-icon"></i>
        <span v-if="variant !== 'minimal'" class="br-btn-text">
            {{ $t('post.page.button.restart') }}
        </span>
    </button>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    computed: {
        hasOperator: {
            get() {
                return this.post.racis.filter(
                    (raci) => raci.is_responsible == 1
                )
            }
        }
    },
    props: ['post', 'variant'],
    data() {
        return {
            loading: false
        }
    },
    methods: {
        ...mapActions('post', ['remindOperator', 'getPostHistories']),
        sendRemindToOperator() {
            this.loading = true
            this.remindOperator(this.post.id)
                .then(() => {
                    this.getPostHistories(this.post.id)
                    this.$store.dispatch('toast', {
                        type: 'success',
                        title: this.$t('post.operator.reminded')
                    })
                })
                .catch((e) => {
                    this.$store.dispatch('dispatchError', e)
                })
                .finally(() => {
                    setTimeout(() => {
                        this.loading = false
                    }, 1000)
                })
        }
    }
}
</script>

<style scoped>
.br-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 8px 16px;
    background: #f59e0b;
    border: none;
    border-radius: 8px;
    color: #fff;
    font-size: 0.82rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.br-btn:hover:not(:disabled) {
    background: #d97706;
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(245, 158, 11, 0.3);
}

.br-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.br-btn-icon {
    font-size: 0.82rem;
    color: #fff !important;
}

.br-btn--minimal {
    width: 32px;
    height: 32px;
    padding: 0;
    border-radius: 8px;
}

.br-btn--minimal .br-btn-icon {
    font-size: 0.78rem;
}

/* Preview variant — used inside the ticket quick-view drawer, solid
 * warning (amber) fill to signal the nudging / recall semantic. */
.br-btn--preview {
    padding: 7px 12px;
    border: 1px solid var(--v2-warning, #f59e0b);
    background: var(--v2-warning, #f59e0b);
    color: #fff;
    font-size: 0.8125rem;
    font-weight: 500;
    border-radius: var(--v2-radius-md, 8px);
    transition: all 120ms ease;
}

.br-btn--preview .br-btn-icon {
    color: #fff !important;
    font-size: 0.85rem;
}

.br-btn--preview:hover:not(:disabled) {
    filter: brightness(0.95);
    transform: none;
    box-shadow: none;
}
</style>
